import { render, staticRenderFns } from "./Ppp3Modal.vue?vue&type=template&id=565adc26&"
import script from "./Ppp3Modal.vue?vue&type=script&lang=js&"
export * from "./Ppp3Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports